// extracted by mini-css-extract-plugin
export default {"wrapper":"emptyData_wrapper__Schnr","status":"emptyData_status__moZ4R","modal":"emptyData_modal__gO5jg"};